export default __webpack_public_path__ + "static/media/1146.50e73d0e.png";